import p from "decimal.js";
import F from "from-exponential";
import * as b from "ramda";
const $ = (i, n, o) => {
  if (isNaN(Number(i)) || b.startsWith("-", i))
    return "0";
  const e = F(i), [t = ""] = e.split(".");
  if (t === "0") {
    const f = new p(e).toExponential(
      o
    ), [u, g] = f.split("e");
    return `${u.replace(/\.0+$/, "")}e${g}`;
  } else {
    if (t.length <= n)
      return new p(e).toFixed(
        Math.min(n - t.length, o)
      );
    if (t.length > n)
      return new p(e).toExponential(o);
  }
  return e;
}, M = (i, n) => {
  const [, o = ""] = i.split(".");
  return o.length > n;
}, N = ["", "K", "M", "B", "T"], A = (i) => {
  const n = +i < 0 ? "-" : "", o = i.toString();
  if (!/e/i.test(o))
    return i;
  const [l, e, t] = i.toString().replace(/^-/, "").replace(/^([0-9]+)(e.*)/, "$1.$2").split(/e|\./);
  return +t < 0 ? n + "0." + "0".repeat(Math.max(Math.abs(parseFloat(t)) - 1 || 0, 0)) + l + e : n + l + (+t >= e.length ? e + "0".repeat(Math.max(+t - e.length || 0, 0)) : e.slice(0, +t) + "." + e.slice(+t));
}, T = (i) => {
  let n = i.toFixed(0);
  n.includes("e") && (n = A(n));
  const o = Math.floor((n.length - 1) / 3);
  return o < b.length(N) ? N[o] || "" : b.last(N);
}, W = (i, n = {}) => {
  const {
    minNumberWithoutENotation: o = 5e-5,
    maxNumberWithoutENotation: l = 1e10,
    maxLength: e = 5,
    maxDecimal: t = 4,
    allowENotation: x = !0,
    eNotationDecimal: f = 2,
    intOnlyOverOne: u = !1,
    allowedLargeNumberAbbr: g = !0,
    largeNumberAbbrMaxDecimal: d = 1,
    priorities: D = ["maxDecimal", "maxLength"]
  } = n, a = i.includes("e") ? Number.parseFloat(i).toLocaleString("en", {
    maximumSignificantDigits: 15,
    useGrouping: !1
  }) : i;
  if (Number.isNaN(Number(a)) || a === "0")
    return "0";
  const s = Number.parseFloat(i), L = x && (s < o || s > l && !g), [h = "", E = ""] = a.split(".");
  if (L)
    return $(a, e, f);
  if (g) {
    const m = T(s);
    if (m) {
      const c = Math.pow(10, N.indexOf(m) * 3);
      return `${(s / c).toLocaleString("en", {
        maximumFractionDigits: d
      })}${m}`;
    }
  }
  if (e === 0)
    return s.toLocaleString("en", {
      maximumFractionDigits: t
    });
  const w = h !== "0" ? {
    maximumSignificantDigits: e
  } : {
    maximumFractionDigits: D.indexOf("maxDecimal") < D.indexOf("maxLength") ? t : e
  };
  let r = Number.parseFloat(a).toLocaleString(
    "en",
    w
  );
  if (u && h !== "0" && (r = Number.parseFloat(a).toLocaleString("en", {
    maximumFractionDigits: 0
  })), h !== "0" && M(r, t) && (r = Number.parseFloat(a).toLocaleString("en", {
    maximumFractionDigits: t
  })), r.length < e && E.length > 0 && !u)
    if (r.includes(".")) {
      const [m, c] = r.split("."), O = `${c}${"0".repeat(
        Math.min(
          e - r.length + 1,
          t - c.length,
          E.length - c.length
        )
      )}`;
      r = `${m}.${O}`;
    } else t > 0 && (r = `${r}.${"0".repeat(
      Math.min(e - r.length, t)
    )}`);
  return r;
}, S = {
  maxDecimal: 2,
  minNumberWithoutENotation: 5e-3,
  allowENotation: !0
}, P = {
  ...S,
  intOnlyOverOne: !0
}, I = {
  ...S,
  allowedLargeNumberAbbr: !1,
  maxLength: 10
}, R = {
  minNumberWithoutENotation: 5e-10,
  maxLength: 10,
  maxDecimal: 9,
  allowedLargeNumberAbbr: !1
};
export {
  P as CARD_USD_OPTIONS,
  I as DETAIL_USD_OPTIONS,
  R as DETAIL_WETH_OPTIONS,
  S as USD_OPTIONS,
  W as formatNumberString
};
//# sourceMappingURL=formatNumberString.js.map
